import { render, staticRenderFns } from "./CheckboxView.vue?vue&type=template&id=f06130d4&scoped=true&"
import script from "./CheckboxView.vue?vue&type=script&lang=js&"
export * from "./CheckboxView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06130d4",
  null
  
)

export default component.exports